import React from 'react';
import './styles.css';

const ICONS = {
  success: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 13l4 4L19 7"
    />
  ),
  warning: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v3.5" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 16h.01" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" fill="none" />
    </>
  ),
  error: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 9l-6 6m0-6l6 6" />
      <circle cx="12" cy="12" r="9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </>
  ),
  info: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 16v-4" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8h.01" />
      <circle cx="12" cy="12" r="9" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </>
  ),
};

const AlertModal = ({
  isOpen,
  title,
  message,
  onClose,
  onConfirm,
  confirmText = 'OK',
  variant = 'info',
  dismissible = true,
}) => {
  if (!isOpen) return null;

  const icon = ICONS[variant] || ICONS.info;
  const handleButtonClick = async () => {
    if (onConfirm) {
      await onConfirm();
    } else if (onClose) {
      onClose();
    }
  };

  const handleOverlayClick = () => {
    if (dismissible && onClose) {
      onClose();
    }
  };

  return (
    <div className="alert-modal-overlay" onClick={handleOverlayClick}>
      <div className="alert-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className={`alert-modal-icon ${variant}`}>
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            {icon}
          </svg>
        </div>
        <h2 className="alert-modal-title">{title}</h2>
        <p className="alert-modal-message">{message}</p>
        <button className="alert-modal-button" onClick={handleButtonClick}>
          {confirmText}
        </button>
      </div>
    </div>
  );
};

export default AlertModal;
